import(/* webpackMode: "eager" */ "/app/app/[team]/page.tsx");
